import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ags-shortcut-button',
  templateUrl: './shortcut-button.component.html',
  styleUrls: ['./shortcut-button.component.scss']
})
export class ShortcutButtonComponent implements OnInit {
  @Input() icon: string;
  @Input() title: string;
  @Input() nbNotif: number;
  // Setter : permet d'indiquer le type que l'on attend en binding
  // (provoquera erreur si pas respecté)
  set _nbNotif(value: number) {
    this.nbNotif = value;
  }

  constructor() {}

  ngOnInit() {}
}
